export default __webpack_public_path__ + "static/envelopeBody-04fc4513d2e9c6a8ffad96cb393aa810.png";